<template>
    <div id="doctor-reset-password-container" class="m-auto auth-form-container">
        <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
                <div class="row">
                    <div class="p-5 w-100">
                        <div class="text-center">
                            <h1 class="h4 text-gray-900 mb-4">
                                <span>{{$t('RESET_PASSWORD')}}</span>
                            </h1>
                        </div>
                        <form class="user" @submit.prevent="submitResetEmail">
                            <div class="form-group">
                                <input v-model="password" type="password" class="form-control form-control-user" :placeholder="$t('PASSWORD')">
                            </div>
                             <div class="form-group">
                                <input v-model="confirmPassword" type="password" class="form-control form-control-user" :placeholder="$t('CONFIRM_PASSWORD')">
                            </div>
                            <button type="submit" class="btn btn-primary btn-user btn-block">{{$t('RESET_PASSWORD')}}</button>
                        </form>
                        <div v-if="message !== ''" class="text-center" role="alert">
                                {{message}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            confirmPassword: '',
            id:'',
            token: '',
            message: ''
        }
    },
    methods: {
        setParams: function(){
            if(!this.$route.query.id || !this.$route.query.t){
                this.$router.push('/404')
            }
            this.id = this.$route.query.id
            this.token = this.$route.query.t
        },
        submitResetEmail: function(){
            if(this.password !== this.confirmPassword){
                this.message = this.$t('PASSWORDS_MUST_MATCH')
                return;
            }
            let self = this
            if(this.id != '' && this.token != ''){
                this.$http.post('/api/auth/reset', {
                    newPassword: self.password,
                    token: self.token,
                    userId: self.id
                })
                .then(response => {
                    self.message = this.$t('PASSWORD_CHANGED') + '!';
                    window.location.href = '/';
                })
                .catch(error => {
                    console.log(error)
                })
            }
        }
    },
    mounted: function(){
        this.setParams()
    }
}
</script>

<style lang="scss">

</style>
